'use client'
import { useTranslation } from '@/app/i18n/client'
import Image from 'next/image'
import AdvertiseForm from './AdvertiseForm'
const AdvertisePageFooterComponent = () => {
  const { t } = useTranslation()

  return (
    <div>
      <div className="w-full flex flex-col items-center mobile-width">
        <div className="w-[788px] mb-[50px] mobile-width">
          <div className="flex bg-[#f8ffea] py-[32px] px-[85px] gap-[51px] mobile-width mobile:flex-col mobile:px-[20px]  mobile:gap-[10px]">
            <p className="text-[20px] font-ns_bold text=[#222222] text-center mobile:text-[16px]">
              {t('Include your advertisement on the fructidor.com')}
            </p>
            <AdvertiseForm />
          </div>

          <h1 className="text-[28px] text-[#222222] font-ns_bold mt-[62px] text-center mobile:mt-[30px] mobile:text-[20px]">
            {t('Advertise and get perks reserved for subscribers')}
          </h1>
          <div className="flex items-start mt-[54px] mobile:mt-[15px]">
            <Image
              loading="lazy"
              width={23.6}
              height={33.4}
              src="/assets/Icons/LockIcon.svg"
              alt=""
            />
            <div className="pr-[20px] ml-[22.4px]">
              <h1 className="text-[18px] text-[#df7d2f] font-ns_bold mobile:text-[16px]">
                {t('Access to Fructidor Database as a subscriber')}
              </h1>
              <p className="text-[16px] text-[#4a4a4a] mt-[16px] mobile:text-[14px] mobile:mt-[5px]">
                {t(
                  'As a subscriber, you will have access to 70.000+ fruit/veg operators in 138 countries: growers, packers, exporters, importers, retail-chain buyers, wholesalers, industry buyers…This includes 5 directories + 1-year access for 3 users.'
                )}
              </p>
            </div>
          </div>
          <div className="flex items-start mt-[30px] mobile:mt-[15px]">
            <Image
              loading="lazy"
              width={23.6}
              height={33.4}
              src="/assets/Icons/RefreshIcon.svg"
              alt=""
            />
            <div className="pr-[20px] ml-[22.4px]">
              <h1 className="text-[18px] text-[#df7d2f] font-ns_bold mobile:text-[16px]">
                {t('Be updated')}
              </h1>
              <p className="text-[16px] text-[#4a4a4a] mt-[16px] mobile:text-[14px] mobile:mt-[5px]">
                {t(
                  'Our Database is updated every day by our team of editors & Country Managers in the field.'
                )}
              </p>
            </div>
          </div>
          <div className="flex items-start mt-[30px] mobile:mt-[15px]">
            <Image
              loading="lazy"
              width={23.6}
              height={33.4}
              src="/assets/Icons/ChatIcon.svg"
              alt=""
            />
            <div className="pr-[20px] ml-[22.4px]">
              <h1 className="text-[18px] text-[#df7d2f] font-ns_bold mobile:text-[16px]">
                {t('Personal assistance')}
              </h1>
              <p className="text-[16px] text-[#4a4a4a] mt-[16px] mobile:text-[14px] mobile:mt-[5px]">
                {t(
                  'You are not alone anymore! For any question, Fructidor Country Managers, located in various countries in the world will be there to help you. More than a platform, you are part of a unique network of fruit experts around the world'
                )}
              </p>
            </div>
          </div>
          <div className="flex items-start mt-[30px] mobile:mt-[15px]">
            <Image
              loading="lazy"
              width={23.6}
              height={33.4}
              src="/assets/Icons/LikeIcon.svg"
              alt=""
            />
            <div className="pr-[20px] ml-[22.4px]">
              <h1 className="text-[18px] text-[#df7d2f] font-ns_bold mobile:text-[16px]">
                {t('Testimonies')}
              </h1>
              <p className="text-[16px] text-[#4a4a4a] mt-[16px] mobile:text-[14px] mobile:mt-[5px]">
                {t(
                  'Check what our customers think about Fructidor.com services'
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdvertisePageFooterComponent
